module.exports = __webpack_public_path__ + "img/yellow_cabinet.cb3f86bb.svg";